<script>
export default {
    name: 'IconPodcast'
}
</script>
<template>
    <svg
        class="base-icon icon-podcast"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M44.966 27.942l5.01.008c-.443 8.49-6.768 15.424-14.976 16.8v5.256h5v6H24v-6h5V44.75c-8.209-1.377-14.534-8.31-14.975-16.801l5.009-.008C19.516 34.682 25.137 40 32 40c6.863 0 12.484-5.318 12.966-12.058zM32 8.007a8 8 0 018 8v11a8 8 0 11-16 0v-11a8 8 0 018-8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
